/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gamecompanies_Ubisoft1Inputs */

const ja_gamecompanies_ubisoft1 = /** @type {(inputs: Gamecompanies_Ubisoft1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubisoft`)
};

const en_gamecompanies_ubisoft1 = /** @type {(inputs: Gamecompanies_Ubisoft1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubisoft`)
};

/**
* | output |
* | --- |
* | "Ubisoft" |
*
* @param {Gamecompanies_Ubisoft1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const gamecompanies_ubisoft1 = /** @type {((inputs?: Gamecompanies_Ubisoft1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gamecompanies_Ubisoft1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_gamecompanies_ubisoft1(inputs)
	return en_gamecompanies_ubisoft1(inputs)
});
export { gamecompanies_ubisoft1 as "gameCompanies_ubisoft" }